module.exports = __webpack_public_path__ + "8f4dd515b3a6ebf9a93f2e63291270f7.jpg";